import { api } from "../base";
import type {
  ISpotReconAcceptRequest,
  ISpotReconBreak,
  ISpotReconQuery,
  ISpotReconRevokeRequest,
  ISpotTradeReconResponse,
} from "@pulse-ui/codegen-v2/generated_ts/spot_trade_recon";

export {
  SpotReconBreakKind,
  SpotReconComparison,
  SpotReconComparisonStatus,
  SpotReconOrigin,
  SpotReconResolution,
  SpotReconRunStatus,
  SpotReconRunTrigger,
  SpotReconView,
  type ISpotReconAcceptRequest,
  type ISpotReconAcceptance,
  type ISpotReconActor,
  type ISpotReconBreak,
  type ISpotReconQuery,
  type ISpotReconRevokeRequest,
  type ISpotReconRun,
  type ISpotReconRunComparison,
  type ISpotReconTrade,
  type ISpotTradeReconResponse,
} from "@pulse-ui/codegen-v2/generated_ts/spot_trade_recon";

// Every field optional and absent rather than null, so the server applies its own defaults.
export type SpotTradeReconParams = { [K in keyof ISpotReconQuery]?: NonNullable<ISpotReconQuery[K]> };

// Served by spot-trade-recon; Risk or Admin only.
const spotTradeReconEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getSpotTradeRecon: build.query<ISpotTradeReconResponse, SpotTradeReconParams>({
      query: (params) => ({
        url: "/api/spot-trade-recon/v1/recon",
        params,
      }),
      providesTags: ["SpotTradeRecon"],
    }),
    // Invalidates on failure too: a 409 means the break moved, so the grid must reload.
    acceptSpotReconBreak: build.mutation<ISpotReconBreak, ISpotReconAcceptRequest>({
      query: (body) => ({
        url: "/api/spot-trade-recon/v1/breaks/accept",
        method: "POST",
        body,
      }),
      invalidatesTags: ["SpotTradeRecon"],
    }),
    revokeSpotReconAcceptance: build.mutation<ISpotReconBreak, ISpotReconRevokeRequest>({
      query: (body) => ({
        url: "/api/spot-trade-recon/v1/breaks/revoke",
        method: "POST",
        body,
      }),
      invalidatesTags: ["SpotTradeRecon"],
    }),
  }),
});

export const {
  useGetSpotTradeReconQuery,
  useAcceptSpotReconBreakMutation,
  useRevokeSpotReconAcceptanceMutation,
} = spotTradeReconEndpoints;
